// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"322":"ce6c453e","498":"d5420828","651":"ae86da98","787":"a0147143","817":"4a7c5feb"}[chunkId] + ".chunk.js";
};